<template>
  <div 
    class="quote-card fade-transition" 
    :class="{ 'fade-out': isTransitioning }"
  >
    <div class="quote-mark left">"</div>
    <div class="quote-mark right">"</div>
    
    <div class="quote-text">
      {{ quote.text }}
    </div>
    
    <div class="quote-author">
      {{ quote.author }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuoteCard',
  props: {
    quote: {
      type: Object,
      required: true,
      default: () => ({
        text: '加载中...',
        author: ''
      })
    },
    isTransitioning: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.quote-card {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(20px);
  border-radius: 30px;
  padding: 60px 50px;
  max-width: 800px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transform: translateY(20px);
  opacity: 0;
  animation: fadeInUp 1.2s ease-out 0.5s forwards;
  position: relative;
  overflow: hidden;
  width: 100%;
}

.quote-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent);
  transition: left 0.5s;
}

.quote-card:hover::before {
  left: 100%;
}

.quote-mark {
  font-size: 4rem;
  color: rgba(255, 255, 255, 0.3);
  line-height: 1;
  font-family: Georgia, serif;
}

.quote-mark.left {
  position: absolute;
  top: 20px;
  left: 30px;
}

.quote-mark.right {
  position: absolute;
  bottom: 20px;
  right: 30px;
  transform: rotate(180deg);
}

.quote-text {
  font-size: 2rem;
  line-height: 1.6;
  color: #ffffff;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  margin: 30px 0;
  position: relative;
  z-index: 2;
  font-weight: 300;
  letter-spacing: 1px;
}

.quote-author {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.8);
  font-style: italic;
  margin-top: 30px;
  position: relative;
  z-index: 2;
}

.quote-author::before {
  content: '—— ';
  color: rgba(255, 255, 255, 0.6);
}

.fade-transition {
  transition: all 0.5s ease-in-out;
}

.fade-out {
  opacity: 0;
  transform: translateY(-20px);
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 移动端响应式 */
@media (max-width: 768px) {
  .quote-card {
    padding: 35px 25px;
    margin: 0;
    max-width: 100%;
    border-radius: 20px;
    width: 100%;
  }

  .quote-text {
    font-size: 1.4rem;
    line-height: 1.5;
    margin: 25px 0;
    letter-spacing: 0.5px;
  }

  .quote-author {
    font-size: 1rem;
    margin-top: 25px;
  }

  .quote-mark {
    font-size: 2.5rem;
  }

  .quote-mark.left {
    top: 15px;
    left: 20px;
  }

  .quote-mark.right {
    bottom: 15px;
    right: 20px;
  }
}

@media (max-width: 480px) {
  .quote-card {
    padding: 30px 20px;
    border-radius: 18px;
  }

  .quote-text {
    font-size: 1.2rem;
    line-height: 1.4;
    margin: 20px 0;
  }

  .quote-author {
    font-size: 0.9rem;
    margin-top: 20px;
  }

  .quote-mark {
    font-size: 2rem;
  }

  .quote-mark.left {
    top: 12px;
    left: 15px;
  }

  .quote-mark.right {
    bottom: 12px;
    right: 15px;
  }
}
</style>